/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GpiStateModel } from '../model/gpiStateModel';
import { GpiStatisticsModel } from '../model/gpiStatisticsModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class GpiService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [PORTAL] Gets a client&#x27;s GPI
     * Returns the specified client&#x27;s GPI for the given local day, or today in the client&#x27;s zone: Ready, Updating (the day is recalculating) or Calibrating with the day count, and the four pillars.
     * @param localDate 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public gpiGet(localDate?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GpiStateModel>;
    public gpiGet(localDate?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GpiStateModel>>;
    public gpiGet(localDate?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GpiStateModel>>;
    public gpiGet(localDate?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (localDate !== undefined && localDate !== null) {
            queryParameters = queryParameters.set('LocalDate', <any>localDate);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GpiStateModel>('get',`${this.basePath}/Gpi`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets a client&#x27;s GPI statistics
     * Returns the specified client&#x27;s GPI for each day of the last 7, 30 or 90 days, the running total of GPI - 50, the four pillar levels and relative capacity, with the pillar cards for the period.
     * @param days 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public gpiStatisticsGet(days?: number, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GpiStatisticsModel>;
    public gpiStatisticsGet(days?: number, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GpiStatisticsModel>>;
    public gpiStatisticsGet(days?: number, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GpiStatisticsModel>>;
    public gpiStatisticsGet(days?: number, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (days !== undefined && days !== null) {
            queryParameters = queryParameters.set('Days', <any>days);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GpiStatisticsModel>('get',`${this.basePath}/Gpi/Statistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets GPI
     * Returns the caller&#x27;s GPI for the given local day, or today: Ready, Updating (the day is recalculating) or Calibrating with the day count, and the four pillars.
     * @param localDate 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meGpiGet(localDate?: string, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GpiStateModel>;
    public meGpiGet(localDate?: string, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GpiStateModel>>;
    public meGpiGet(localDate?: string, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GpiStateModel>>;
    public meGpiGet(localDate?: string, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (localDate !== undefined && localDate !== null) {
            queryParameters = queryParameters.set('LocalDate', <any>localDate);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GpiStateModel>('get',`${this.basePath}/Me/Gpi`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets GPI statistics
     * Returns each day&#x27;s GPI, the running total of GPI - 50, the four pillar levels and relative capacity over the last 7, 30 or 90 days, with the pillar cards for the period.
     * @param days 
     * @param clientUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meGpiStatisticsGet(days?: number, clientUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GpiStatisticsModel>;
    public meGpiStatisticsGet(days?: number, clientUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GpiStatisticsModel>>;
    public meGpiStatisticsGet(days?: number, clientUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GpiStatisticsModel>>;
    public meGpiStatisticsGet(days?: number, clientUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (days !== undefined && days !== null) {
            queryParameters = queryParameters.set('Days', <any>days);
        }
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GpiStatisticsModel>('get',`${this.basePath}/Me/Gpi/Statistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
